import { render, staticRenderFns } from "./SupplierUpdateCatalogPage.vue?vue&type=template&id=68cf63ca&"
import script from "./SupplierUpdateCatalogPage.vue?vue&type=script&lang=js&"
export * from "./SupplierUpdateCatalogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports